import { z } from 'zod'

export const rtmpUrlSchema = z
  .string()
  .trim()
  .regex(
    /^rtmps?:\/\/[^\s]+$/,
    'Please enter a valid RTMP URL (e.g., rtmp://server.com:1935/live)'
  )

export const rtmpStreamKeySchema = z
  .string()
  .min(1, 'Stream key cannot be empty')

export const rtmpFormSchema = z.object({
  url: rtmpUrlSchema,
  streamKey: rtmpStreamKeySchema,
})
export type RtmpForm = z.infer<typeof rtmpFormSchema>
